import { Page } from '@/core/architecture'

import { ConsoleCollectionEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCollectionEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleCollectionEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCollectionEditTemplate state={state} {...actions} />
}
